import EmblaCarousel from 'embla-carousel';
import { domReady } from '../modules/utils.js';

class ContentCarousel extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = {
      left: this.querySelector('.contentcarousel-left'),
      right: this.querySelector('.contentcarousel-right'),
    };
    this.#setListeners();
    this.#initSlider();
  }

  disconnectedCallback() {
    this.#unsetListeners();
    this.carousel?.destroy();
  }

  #setListeners() {
    this.refs.left?.addEventListener('click', this.#onClickPrev);
    this.refs.right?.addEventListener('click', this.#onClickNext);
  }

  #unsetListeners() {
    this.refs.left?.removeEventListener('click', this.#onClickPrev);
    this.refs.right?.removeEventListener('click', this.#onClickNext);
  }

  #onClickPrev = () => {
    this.carousel?.scrollPrev();
  };

  #onClickNext = () => {
    this.carousel?.scrollNext();
  };

  #updateNav = () => {
    this.refs.left?.classList.toggle('is-disabled', !this.carousel.canScrollPrev());
    this.refs.right?.classList.toggle('is-disabled', !this.carousel.canScrollNext());
  };

  #initSlider() {
    const viewPortEl = this.querySelector('.slider-viewport');
    this.carousel = EmblaCarousel(viewPortEl, {
      align: 'start',
      dragFree: true,
      containScroll: true,
    });

    this.carousel.on('select', this.#updateNav);
    this.carousel.on('reInit', this.#updateNav);
    this.#updateNav();
  }
}

customElements.define('content-carousel', ContentCarousel);
